import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { BrowserModule } from '@campus/browser';
import { ComponentsModule } from '@campus/components';
import { DalModule } from '@campus/dal';
import { SearchModule } from '@campus/search';
import { CONTENT_OPENER_TOKEN, DefaultContentOpenerService, SharedModule } from '@campus/shared';
import { SvgModule } from '@campus/svg';
import { UiModule } from '@campus/ui';
import { dcrIconService } from '@diekeure/dcr-components';
import {
  EduContentResultListItemComponent,
  ImageDictSlideoutComponent,
  ResultListItemComponent,
  ScoreScatterComponent,
  ScoreScatterV2Component,
  TocResultDisplayItemComponent,
  TocResultGridItemComponent,
  TocResultGridItemGroupsComponent,
  TocResultListItemComponent,
  TocResultListItemGroupsComponent,
} from './components';
import { icons } from './icons';
import { TocResultService } from './services';

dcrIconService.registerIcons(icons);

@NgModule({
  imports: [
    CommonModule,
    SvgModule,
    SharedModule,
    UiModule,
    MatBadgeModule,
    DalModule,
    ComponentsModule,
    SearchModule,
    BrowserModule,
  ],
  declarations: [
    TocResultListItemComponent,
    TocResultListItemGroupsComponent,
    EduContentResultListItemComponent,
    ImageDictSlideoutComponent,
    TocResultGridItemComponent,
    TocResultGridItemGroupsComponent,
    TocResultDisplayItemComponent,
    ResultListItemComponent,
    ScoreScatterComponent,
    ScoreScatterV2Component,
  ],
  exports: [
    TocResultListItemComponent,
    TocResultListItemGroupsComponent,
    EduContentResultListItemComponent,
    ImageDictSlideoutComponent,
    TocResultGridItemComponent,
    TocResultGridItemGroupsComponent,
    TocResultDisplayItemComponent,
    ResultListItemComponent,
    ScoreScatterComponent,
    ScoreScatterV2Component,
  ],
  providers: [
    TocResultService,
    {
      provide: CONTENT_OPENER_TOKEN,
      useClass: DefaultContentOpenerService,
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PagesSharedModule {}
